import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import store from './store'
import './registerServiceWorker'

import 'highlight.js/styles/github.css';
import Highlight from 'vue-markdown-highlight'
Vue.use(Highlight)
import Hljs from 'highlight.js'



Vue.config.productionTip = false

// var MarkdownIt  = require('markdown-it');
var md = require('jstransformer')(require('jstransformer-markdown-it'));
// var VueMarkdown = require('vue-markdown');
// Vue.component('vue-markdown',VueMarkdown);

Vue.prototype.$md = md;
Vue.prototype.$higlight_all = async function(vue) {
  vue.$nextTick(() => { 
    let blocks = vue.$el.querySelectorAll("pre code");
     blocks.forEach((block) => {
         Hljs.highlightBlock(block)
     })
   });
}


Vue.prototype.$get = async function(src) {
  let response = new Promise(resolve => {
      var request = new XMLHttpRequest();
      // let text = require( '../assets/colors/material.md');
      let url = 'source/' + src;
      request.onerror = function () {
        resolve('');
      }
      request.onreadystatechange = function () {
          if (request.readyState === 4 && request.status === 200) {
              var type = request.getResponseHeader('Content-Type');
              if (type.indexOf("text") !== 1) {
                  resolve(request.responseText);
                  // console.log(request.responseText);
                  return;
              }
          }
      }
      request.open('GET',url, true);
      request.send(null);
  })
  return response;
}



new Vue({
  // router,
  store,
  render: h => h(App)
}).$mount('#app')
